<template>
  <div>
    <ValidationObserver
      ref="formValidation"
      v-slot="{ invalid }"
      slim
    >
      <form
        role="form"
        class="form-horizontal"
        name="apiTokenForm"
        novalidate
        @submit.prevent="onSave"
      >
        <fieldset>
          <div class="form-group">
            <label
              v-t="'NAME'"
              class="col-sm-3 col-md-3 control-label"
            >
              <a
                tooltip-class="tooltip-white"
                tooltip-placement="right"
                tooltip-append-to-body="true"
              >
                &nbsp;&nbsp;<i class="fa fa-question-circle" />
              </a>
            </label>
            <div class="col-sm-4 col-md-2">
              <ValidationProvider
                rules="required"
                slim
              >
                <input
                  v-model="apiToken.name"
                  v-focus
                  required
                  type="text"
                  class="form-control"
                  name="name"
                  custom-autofocus="true"
                  placeholder="Name"
                >
              </validationprovider>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3">
              <button
                v-t="'ADD_BUTTON_TEXT'"
                type="button"
                class="btn btn-primary btn-sm"
                :disabled="invalid"
                @click="onSave"
              />
              <button
                v-t="'CANCEL_BUTTON_TEXT'"
                type="button"
                class="btn btn-sm btn-danger m-l-15"
                @click="closeForm"
              />
            </div>
          </div>
        </fieldset>

        <ConfirmationModal 
          v-if="showConfirmation"
          :entity="apiToken"
          :title="$t('API_TOKEN_SUCCESS')"
          :cancel-button-text="$t('CLOSE')"
          :confirm-custom-action-text="$t('COPY_TOKEN')"
          :show-confirm-button="false"
          :show-header-close-button="false"
          :show-custom-button="true"
          :allow-modal-to-be-closed="tokenHasBeenCopied"
          @custom-action="copyToken"
          @close="onCloseApiTokenModal"
        >
          <span>
            <i
              class="p-0 typcn yellow typcn-warning"
              tooltip-placement="left"
            />
            <label v-t="'CREATED_TOKEN_STORE_SAFE_LOCATION_WARNING'" />
          </span>
          <div class="m-t-10 m-b-10 well well-sm">
            <span class="token-content"> 
              <b> {{ createdApiTokenResponse.token }} </b>
            </span>
          </div>

          <div class="checkbox f-s-14">
            <label>
              <input
                v-model="tokenHasBeenCopied"
                type="checkbox"
                class="m-t-4"
              >
              <span v-t="'I_HAVE_COPIED_THE_TOKEN'" />
            </label>
          </div>
        </ConfirmationModal>
      </form>
    </validationobserver>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import messages from '../../locales';
import copy from 'copy-to-clipboard';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'ApiTokenForm',
  components: {
    ConfirmationModal
  },
  
  data() {
    return {
      apiToken: {},
      tokenHasBeenCopied: false
    };
  }, 

  computed: {
    ...mapState('apiTokens', {
      createdApiTokenResponse: state => state.createdApiTokenResponse.data
    }),
    tokenContent() {
      return this.createdApiTokenResponse && this.createdApiTokenResponse.token;
    },
    showConfirmation() {
      return this.tokenContent !== undefined;
    }
  }, 

  methods: {
    ...mapActions('apiTokens', [
      'cleanCreatedApiToken'
    ]),
    closeForm() {
      this.cleanCreatedApiToken();
      this.$emit('close-api-token-form');
    },
    onSave() {
      this.$emit('create-api-token', this.apiToken);
    },
    onCloseApiTokenModal() {
      if (!this.tokenHasBeenCopied) {
        utilities.showToaster('warning', this.$i18n.t('YOU_HAVE_TO_COPY_THE_TOKEN'));
        return;
      }

      this.closeForm();
    },
    copyToken() {
      copy(this.tokenContent);
      this.tokenHasBeenCopied = true;
      utilities.showToaster('success', this.$i18n.t('TOKEN_HAS_BEEN_COPIED_TO_CLIPBOARD'));
    }
  },  
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>
.token-content {
  width:100%;
  word-wrap:break-word;
  display:inline-block;
  font-weight: bold;
}
</style>